import React, { useState } from 'react';
import { Users, LogIn } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import './LoginGate.css';

interface LoginGateProps {
  returnTo: string;
}

/**
 * The login trigger (D9) — shown in place of a protected page when the
 * visitor has no web session. Distinct from, and unrelated to, `/auth/login`
 * (the mobile app's credential bridge): this button starts the new
 * community_web_app Authorization Code + PKCE flow via AuthService.beginLogin().
 */
const LoginGate: React.FC<LoginGateProps> = ({ returnTo }) => {
  const { login } = useAuth();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleSignIn = () => {
    setIsRedirecting(true);
    login(returnTo);
  };

  return (
    <div className="login-gate-root">
      <div className="lg-card">
        <div className="lg-icon">
          <Users size={28} />
        </div>
        <h1 className="lg-title">Sign in to see your community</h1>
        <p className="lg-sub">
          Your referral code, community score, and everyone you've brought into GetSpeakHub live here.
        </p>
        <button className="lg-btn" onClick={handleSignIn} disabled={isRedirecting}>
          {isRedirecting ? (
            <span className="lg-spinner" />
          ) : (
            <>
              <LogIn size={18} />
              Sign in
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default LoginGate;
